import { render, staticRenderFns } from "./TaskChangeDescription.vue?vue&type=template&id=0033e909&scoped=true&lang=pug&"
import script from "./TaskChangeDescription.vue?vue&type=script&lang=js&"
export * from "./TaskChangeDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0033e909",
  null
  
)

export default component.exports